/* Tmedals V053: one small, server-rendered arrivals feed. No catalogue scan,
   no fake 'latest' fallback, no hardcoded price or product data. */
(() => {
  'use strict';
  if (window.TMHomeV053) { window.TMHomeV053.init(document); return; }
  const feeds = new Map();
  let sequence = 0;

  function feedUrl(root) {
    const url = new URL(root.dataset.source, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid feed origin');
    // The new data view must come from the PREVIEW theme, not the published theme.
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    if (!url.searchParams.has('preview_theme_id') && window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main' && window.Shopify.theme.id) {
      url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    }
    return url.toString();
  }

  async function requestFeed(url) {
    if (feeds.has(url)) return feeds.get(url);
    const task = (async () => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, {
          credentials: 'same-origin', signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Arrivals HTTP ${response.status}`);
        const markup = await response.text();
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const feed = doc.querySelector('[data-tm53-product-feed]');
        if (!feed) throw new Error('Missing arrivals feed');
        return feed;
      } finally { window.clearTimeout(timer); }
    })();
    feeds.set(url, task);
    try { return await task; }
    catch (error) { feeds.delete(url); throw error; }
  }

  // A merchant can add two arrivals sections. Keep all IDs and ARIA refs unique.
  function uniqueIds(root) {
    const prefix = `tm53-${++sequence}-`;
    const mapping = new Map();
    root.querySelectorAll('[id]').forEach(node => {
      const old = node.id; node.id = prefix + old; mapping.set(old, node.id);
    });
    root.querySelectorAll('[aria-labelledby],[aria-describedby],[for],a[href^="#"]').forEach(node => {
      ['aria-labelledby','aria-describedby','for'].forEach(attr => {
        if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).split(/\s+/).map(id => mapping.get(id) || id).join(' '));
      });
      const href = node.getAttribute('href');
      if (href?.startsWith('#') && mapping.has(href.slice(1))) node.setAttribute('href', '#' + mapping.get(href.slice(1)));
    });
  }

  async function load(root) {
    if (root.dataset.state === 'loading' || root.dataset.state === 'loaded') return;
    const target = root.querySelector('[data-tm53-arrivals-results]');
    const status = root.querySelector('[data-tm53-status]');
    const error = root.querySelector('[data-tm53-error]');
    if (!target) return;
    root.dataset.state = 'loading';
    target.hidden = false;
    target.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    if (status) { status.hidden = false; status.textContent = 'Loading the latest additions…'; }
    try {
      const feed = await requestFeed(feedUrl(root));
      if (!root.isConnected) return;
      const clone = feed.cloneNode(true);
      const limit = root.dataset.limit === '8' ? 8 : 4;
      [...clone.children].slice(limit).forEach(node => node.remove());
      // This view contains native product cards only, never executable script.
      clone.querySelectorAll('script').forEach(node => node.remove());
      uniqueIds(clone);
      if (!clone.children.length) throw new Error('No arrivals available');
      target.replaceChildren(clone);
      target.removeAttribute('aria-busy');
      root.dataset.state = 'loaded';
      if (status) status.textContent = `${clone.children.length} latest additions loaded.`;
      window.TMFavorites?.sync?.(target);
    } catch (_) {
      if (!root.isConnected) return;
      root.dataset.state = 'error';
      target.hidden = true;
      target.removeAttribute('aria-busy');
      if (status) { status.textContent = ''; status.hidden = true; }
      if (error) error.hidden = false;
    }
  }

  function init(scope) {
    const roots = [];
    if (scope.matches?.('[data-tm53-arrivals]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-tm53-arrivals]'));
    roots.forEach(root => {
      if (root.dataset.tm53Ready) return;
      root.dataset.tm53Ready = 'true';
      root.querySelector('[data-tm53-retry]')?.addEventListener('click', () => load(root));
      // Start one request early so the cards are ready by the time the visitor scrolls.
      load(root);
    });
  }
  window.TMHomeV053 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
